import { render, staticRenderFns } from "./AppProductSlider.vue?vue&type=template&id=6d460bfc"
import script from "./AppProductSlider.vue?vue&type=script&lang=ts"
export * from "./AppProductSlider.vue?vue&type=script&lang=ts"
import style0 from "./AppProductSlider.vue?vue&type=style&index=0&id=6d460bfc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports